import styled from "styled-components";

export const Title = styled.h2`
  margin: 25px 0 10px;
`;
